/**
 * orga-app-api - kommunikation-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TroubleTicketIdentifier { 
    troubleticket_id: string;
    mandant_id: string;
    modified_on_utc: Date;
}

